import { LayoutGrid } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const GridIcon = createLucideIcon(LayoutGrid);
